"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignModuleCounter = exports.campaignPriceCalculator = exports.isFreeTier = void 0;
/**
 * Checks if a campaign meets the condition of free tier
 * returns the condition and the valued price
 *
 * @category UTILS
 *
 * @param {CampaignItem} campaign The campaign object
 *
 * @returns {FreeTierResponse} The response of a free tier
 */

function isFreeTier(campaign) {
  var free = true;
  var message = "Your campaign is under free tier!";

  var _a = campaignModuleCounter(campaign),
      modulesCount = _a.modulesCount,
      video_t = _a.video_t,
      video_m = _a.video_m,
      image_t = _a.image_t,
      image_m = _a.image_m,
      audio_t = _a.audio_t,
      audio_m = _a.audio_m,
      qa_m = _a.qa_m,
      video_stimuli = _a.video_stimuli,
      audio_stimuli = _a.audio_stimuli,
      image_stimuli = _a.image_stimuli,
      qa_stimuli = _a.qa_stimuli;

  if (video_t > 30 || image_t > 30 || audio_t > 30) {
    free = false;
    message = "One or serveral modules have a duration greater than 30''";
  }

  if (video_m > 1 || image_m > 1 || audio_m > 1 || qa_m > 1) {
    free = false;
    message = "Only one module of each type is allowed";
  }

  if (Math.max.apply(Math, __spreadArrays(video_stimuli, audio_stimuli, image_stimuli, qa_stimuli)) > 2) {
    free = false;
    message = "Only two stimulis for each module are allowed";
  }

  if (modulesCount > 4) {
    free = false;
    message = "Only four modules are allowed";
  }

  if (parseInt(campaign.data.audience) > 50) {
    free = false;
    message = "Only 50 testers are allowed";
  }

  var price = campaignPriceCalculator(campaign);
  return {
    free: free,
    message: message,
    price: price
  };
}

exports.isFreeTier = isFreeTier;
/**
 * Calculate the price for the campaign
 *
 * @category UTILS
 *
 * @param {CampaignItem} campaign The campaign object
 *
 * @returns {number} Price in cents of euro
 */

function campaignPriceCalculator(campaign) {
  // TODO: implement real price logic here
  // Price for a campaign is 0.008€/sec * audience
  var target_audience = campaign.data.audience;

  var _a = campaignModuleCounter(campaign),
      total_t = _a.total_t,
      qas = _a.qas; // Stripe works in cents so 0.008 will be .8 cents


  var price = .8 * total_t * parseInt(target_audience) + qas * 2; // Stripe minimum amount is 100

  console.log(parseInt(target_audience), price);

  if (price < 100) {
    price = 100;
  }

  return Math.round(price);
}

exports.campaignPriceCalculator = campaignPriceCalculator;
/**
 * Calculate the modules, times of the interactions and technologies in use for a campaign
 *
 * @category UTILS
 *
 * @param campaign The campaign object
 *
 * @returns {CampaignModuleCount} The object with the modules details
 */

function campaignModuleCounter(campaign) {
  var modules = campaign.data.modules.campaignModules;
  var video_t = 0;
  var audio_t = 0;
  var image_t = 0;
  var qas = 0;
  var tech = new Set();
  var video_modules = modules.filter(function (m) {
    return m.type === 'video';
  });
  var video_m = video_modules.length;
  var video_stimuli = [];
  video_modules.forEach(function (v) {
    var videos = v.videos;
    tech.add(v.tech);
    video_stimuli.push(videos.length);
    videos.forEach(function (m) {
      video_t = video_t + m.duration;
    });
  });
  var audio_modules = modules.filter(function (m) {
    return m.type === 'audio';
  });
  var audio_m = audio_modules.length;
  var audio_stimuli = [];
  audio_modules.forEach(function (a) {
    var audios = a.audios;
    tech.add(a.tech);
    audio_stimuli.push(audios.length);
    audios.forEach(function (m) {
      audio_t = audio_t + m.duration;
    });
  });
  var image_modules = modules.filter(function (m) {
    return m.type === 'image';
  });
  var image_m = image_modules.length;
  var image_stimuli = [];
  image_modules.forEach(function (i) {
    tech.add(i.tech);
    var images = i.images.length;
    image_stimuli.push(images);
    image_t = image_t + images * i.duration;
  });
  var qa_modules = modules.filter(function (m) {
    return m.type === 'qa';
  });
  var qa_m = qa_modules.length;
  var qa_stimuli = [];
  qa_modules.forEach(function (qa) {
    qa_stimuli.push(qa.questions.length);
    qas = qas + qa.questions.length;
  });
  var modulesCount = campaign.data.modules.campaignModules.length;
  return {
    modulesCount: modulesCount,
    total_t: video_t + image_t + audio_t,
    video_t: video_t,
    video_m: video_m,
    image_t: image_t,
    image_m: image_m,
    audio_t: audio_t,
    audio_m: audio_m,
    qa_m: qa_m,
    video_stimuli: video_stimuli,
    audio_stimuli: audio_stimuli,
    image_stimuli: image_stimuli,
    qa_stimuli: qa_stimuli,
    tech: tech,
    qas: qas
  };
}

exports.campaignModuleCounter = campaignModuleCounter;